import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'

/**
 * @const onInidividualCheckboxSelect
 * @description When an individual checkbox in a row is checked
 * @param item
 * @param value
 * @param onChange
 */
const onIndividualCheckboxSelect = (item, value, onChange) => {
  const parsedValue = JSON.parse(value)
  if (parsedValue[item._id]) {
    delete parsedValue[item._id]
    delete parsedValue.all
  } else {
    parsedValue[item._id] = item
  }
  onChange(JSON.stringify(parsedValue))
}

/**
 * @const onSelectAll
 * @description When the "Select All" checkbox is checked
 * @param value
 * @param data
 * @param onChange
 */
const onSelectAll = (value, data, onChange) => {
  let parsedValue = JSON.parse(value)
  if (parsedValue.all) {
    parsedValue = {
      all: false
    }
  } else {
    parsedValue = data.reduce((acc, item) => {
      acc[item._id] = item
      return acc
    }, {})
    parsedValue.all = true
  }
  onChange(JSON.stringify(parsedValue))
}

const renderTableInput = ({ input: { value, onChange }, ...rest }) => {
  const parsedValue = JSON.parse(value)
  return (
    <div>
      {rest.label && <label>{rest.label}</label>}
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
          <tr>
            <td>
              <input type="checkbox" onChange={() => onSelectAll(value, rest.data, onChange)} checked={parsedValue.all} />
            </td>
            {rest.colNames.map(colName => (
              <th key={colName.value}>{colName.displayName}</th>
            ))}
          </tr>
          </thead>
          <tbody>
          {rest.data.map(item => (
            <tr key={item._id}>
              <td>
                <input type="checkbox" onClick={() => onIndividualCheckboxSelect(item, value, onChange)} checked={parsedValue[item._id]} />
              </td>
              {rest.colNames.map(colName => (
                <td key={colName.value}>{get(item, colName.value)}</td>
              ))}
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

renderTableInput.propTypes = {
  colNames: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.arrayOf(PropTypes.object),
  input: PropTypes.any.isRequired,
  label: PropTypes.string,
}

renderTableInput.defaultProps = {
  data: [],
  label: null,
}

export default renderTableInput



// WEBPACK FOOTER //
// ./src/components/ui/forms/renderTableInput.js